// extracted by mini-css-extract-plugin
export default {"remember-me-checkbox":"Checkbox_remember-me-checkbox__4Wyf8","remember-me-label":"Checkbox_remember-me-label__s+KeB","remember-me-text":"Checkbox_remember-me-text__9Q7RP"};